import React from 'react';
import { Grid, TextField } from '@mui/material';
import { UtilityService } from '../../../types/utility.types';

interface OtherFormProps {
  formData: UtilityService;
  handleFormChange: (field: string, value: any) => void;
  handleNestedChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isViewMode: boolean;
}

/**
 * Component for other utility types (PPA_EXPORT_CONTRACT, EV, etc.)
 */
const OtherForm: React.FC<OtherFormProps> = ({
  formData,
  handleFormChange,
  handleNestedChange,
  isViewMode,
}) => {
  // Service types that use Contract Value instead of Commission Uplift
  const contractValueServiceTypes = [
    'EV',
    'Insurance',
    'Merchant Services',
    'New Connection',
    'Renewable',
    'Renewables'
  ];

  const useContractValue = contractValueServiceTypes.some(type => 
    formData.serviceType?.toUpperCase().includes(type.toUpperCase())
  );

  return (
    <Grid container spacing={3}>
      {/* Reference Number */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Reference Number"
          name="meterDetails.meterType"
          value={formData.meterDetails?.meterType || ''}
          onChange={handleNestedChange}
          disabled={Boolean(isViewMode)}
        />
      </Grid>
      
      {/* Location/Identifier */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Location/Identifier"
          name="meterDetails.location"
          value={formData.meterDetails?.location || ''}
          onChange={handleNestedChange}
          disabled={Boolean(isViewMode)}
        />
      </Grid>
      
      {/* Current Rate */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Current Rate"
          name="currentRate"
          value={formData.currentRate || ''}
          onChange={(e) => handleFormChange('currentRate', e.target.value)}
          disabled={Boolean(isViewMode)}
        />
      </Grid>
      
      {/* Contract Value or Commission Uplift */}
      <Grid item xs={12} md={6}>
        {useContractValue ? (
          <TextField
            fullWidth
            label="Contract Value"
            name="contractValue"
            value={formData.contractValue || ''}
            onChange={(e) => {
              // Only allow numbers and decimal point
              const value = e.target.value;
              if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                handleFormChange('contractValue', value);
              }
            }}
            disabled={Boolean(isViewMode)}
            InputProps={{
              startAdornment: <span style={{ marginRight: '4px' }}>£</span>,
            }}
            helperText="Enter contract value in pounds"
          />
        ) : (
          <TextField
            fullWidth
            label="Commission Uplift"
            name="commissionUplift"
            value={formData.commissionUplift || ''}
            onChange={(e) => handleFormChange('commissionUplift', e.target.value)}
            disabled={Boolean(isViewMode)}
            helperText="pence"
          />
        )}
      </Grid>
    </Grid>
  );
};

export default OtherForm;
